import React from 'react';
import SimpleNewsletterCard from './SimpleNewsletterCard';
import { useTranslations } from '../../localization/useTranslations';
import { usePremiumStatus } from '../helpers/CheckPremiumStatus';
import { PremiumNewslettersSectionProps } from '../types/NewsletterPage';

const PremiumNewslettersSection: React.FC<PremiumNewslettersSectionProps> = ({
  premiumNewsletters,
  handlePremiumLinkClick,
  onNewsletterChange,
  checkIsSubscribed,
  premiumLink,
}) => {
  const translations = useTranslations();
  const { isUserPremium } = usePremiumStatus();

  const handleLinkClick = (event: React.MouseEvent) => {
    event.preventDefault();

    if (isUserPremium) {
      window.location.href = premiumLink || '/predplatne';
    } else {
      handlePremiumLinkClick(event);
    }
  };

  return (
    <div className="page-newsletter__section--premium">
      <div className="page-newsletter__section-header">
        <h4 className="page-newsletter__section-title">
          {translations?.newsletterPage?.premiumNewsletterSectionTitle || 'Premium newsletters'}
        </h4>
        <p className="page-newsletter__section-description basic-16">
          {translations?.newsletterPage?.premiumNewsletterSectionDescription ||
            'Enjoy an exclusive newsletter just for Forbes Premium subscribers.'}
        </p>
        {!isUserPremium && (
          <span className="page-newsletter__section-link link-underline-16" onClick={handleLinkClick}>
            {translations?.newsletterPage?.premiumNewsletterSectionLink || 'Learn more'}
          </span>
        )}
      </div>

      {premiumNewsletters && (
        <div className="row">
          {premiumNewsletters.map((newsletter, index) => (
            <div className="col-lg-3 col-md-4 col-12" key={index}>
              <SimpleNewsletterCard
                newsletter={newsletter}
                isSubscribed={checkIsSubscribed(newsletter)}
                onChange={onNewsletterChange}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PremiumNewslettersSection;
